export const PROMOTION_METHODS = [
    { value: 'social_media', label: 'Social Media' },
    { value: 'school_events', label: 'School Events' },
    { value: 'workshops', label: 'Workshops' },
    { value: 'flyers', label: 'Flyers/Posters' },
    { value: 'word_of_mouth', label: 'Word of Mouth' },
    { value: 'partnerships', label: 'Partnerships' },
    { value: 'other', label: 'Other' }
];

export const PROMOTION_METHODS_MAP = {
    "social_media": { label: "Social Media" },
    "school_events": { label: "School Events" },
    "workshops": { label: "Workshops" },
    "flyers": { label: "Flyers/Posters" },
    "word_of_mouth": { label: "Word of Mouth" },
    "partnerships": { label: "Partnerships" },
    "other": { label: "Other" }
};
